export function looksLikeSlug(text) {
  if (!text) return false;
  const normalized = String(text).trim().replace(/\s+/g, "_");
  return /^[a-z0-9_]+$/.test(normalized);
}

export function humanizeSlug(text) {
  if (!text) return "";
  return String(text)
    .replace(/_user_confirm$/, "")
    .replace(/_approved$/, "")
    .replace(/_rejected$/, "")
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function resolveDisplayStepLabel(item) {
  const raw =
    item?.displayStepLabel ||
    item?.stepLabel ||
    item?.currentApproval?.stepLabel ||
    "";
  if (!raw) return "";
  if (!looksLikeSlug(raw)) return raw;
  return humanizeSlug(raw);
}
